import { render, staticRenderFns } from "./AprovarNotasFiscaisDeServicoReprovarNotasModalView.vue?vue&type=template&id=96d93618&scoped=true"
import script from "./AprovarNotasFiscaisDeServicoReprovarNotasModalView.vue?vue&type=script&lang=js"
export * from "./AprovarNotasFiscaisDeServicoReprovarNotasModalView.vue?vue&type=script&lang=js"
import style0 from "./AprovarNotasFiscaisDeServicoReprovarNotasModalView.vue?vue&type=style&index=0&id=96d93618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d93618",
  null
  
)

export default component.exports